import React from "react";
import SEO from "../components/SEO.jsx";
import Header from "../partials/header/Header.jsx";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb.js";
import Footer from "../container/Footer/Footer.js";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo.js";

const CallForPaper = () => {
  return (
    <React.Fragment>
      <SEO title="Call for Papers  | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Call for Papers"
        content="For Authors"
        contentTwo="Call for Papers"
        linkage="/"
      />

      <EmptyTwo>
        <div className="entry-content">
          <h2>Call for Papers</h2>
          <p>
            The International Conference on Swarm Intelligence (ICSI) 2026 invites
            researchers, practitioners, and industry experts to submit their
            original research papers and abstracts. ICSI 2026 aims to provide a
            platform for discussing the latest advancements in swarm intelligence,
            evolutionary computing, and related fields.
          </p>

          <h3>Topic Areas</h3>
          <table className="topic">
            <tbody>
              <tr>
                <th width="100">Theories</th>
                <th width="100">Algorithms</th>
                <th width="100">Realizations</th>
                <th width="100">Emerging Areas</th>
                <th width="100">Applications</th>
              </tr>
              <tr>
                <td>
                  <ul>
                    <li>Swarm intelligence optimization theories</li>
                    <li>Swarm computing</li>
                    <li>Swarm emulation</li>
                    <li>Natural computing</li>
                    <li>Evolutionary computing</li>
                    <li>Social evolution</li>
                    <li>Cooperative theories</li>
                    <li>Optimization theories</li>
                    <li>Immune system theory</li>
                    <li>Multi-agent system theories</li>
                    <li>Reinforcement learning</li>
                    <li>Swarm Robotics</li>
                    <li>Evolutionary learning</li>
                    <li>Collective intelligence</li>
                    <li>Social intelligence</li>
                  </ul>
                </td>

                <td>
                  <ul>
                    <li>PSO algorithms</li>
                    <li>ACO algorithms</li>
                    <li>Fireworks algorithms</li>
                    <li>Fish school search</li>
                    <li>Bees algorithms</li>
                    <li>ABC algorithms</li>
                    <li>BSO algorithms</li>
                    <li>Cultural algorithms</li>
                    <li>Social computing</li>
                    <li>Genetic algorithms</li>
                    <li>Differential evolution</li>
                    <li>Memetic algorithms</li>
                    <li>Bioinspired algorithm</li>
                    <li>Cuckoo / Firefly / Bat / Pelican Algorithms</li>
                    <li>Biogeography-based Optimization</li>
                    <li>Evolutionary strategy</li>
                    <li>Evolutionary Learning systems</li>
                    <li>GPU Computing</li>
                    <li>Other swarm-based algorithms</li>
                  </ul>
                </td>

                <td>
                  <ul>
                    <li>Swarm models</li>
                    <li>Swarm cooperation</li>
                    <li>Multi-agent systems</li>
                    <li>AIS system</li>
                    <li>Evolv. intelligent agents</li>
                    <li>Analytic models of emergent behaviors</li>
                    <li>Evolving fuzzy system</li>
                    <li>Evolving neural nets</li>
                    <li>Artificial life</li>
                    <li>Bio-inspired computing models</li>
                    <li>Socio-inspired computing models</li>
                    <li>Routing and scheduling</li>
                    <li>MOO, Many-OO</li>
                    <li>Constrained OP</li>
                    <li>Dynamic OP</li>
                    <li>Combinatorial OP</li>
                    <li>GPU Parallelization</li>
                    <li>Other swarm-based systems</li>
                  </ul>
                </td>

                <td>
                  <ul>
                    <li>Large language models</li>
                    <li>Swarm intelligence & evolutionary computing for large language model optimization</li>
                    <li>Large language model based evolution computation</li>
                    <li>Large language model based swarm intelligence</li>
                    <li>Large language model based multi-agent systems</li>
                    <li>Molecular computing</li>
                    <li>DNA computing</li>
                    <li>Quantum computing</li>
                    <li>Granularity computing</li>
                    <li>Deep computing</li>
                    <li>Pervasive computing</li>
                    <li>Cloud computing</li>
                    <li>Metaverse</li>
                  </ul>
                </td>

                <td>
                  <ul>
                    <li>UAV control</li>
                    <li>Swarm cooperation</li>
                    <li>Automatic control</li>
                    <li>Intelligent transport</li>
                    <li>Information security</li>
                    <li>Machine learning</li>
                    <li>Image Processing</li>
                    <li>Image Recognition</li>
                    <li>Neural Network</li>
                    <li>Robotic manipulator</li>
                    <li>Cognitive robots</li>
                    <li>Virtual swarms</li>
                    <li>AR+VR techniques</li>
                    <li>Bioinformatics</li>
                    <li>Telecommunications</li>
                    <li>Underwater vehicles</li>
                    <li>Automatic driving</li>
                    <li>Games</li>
                    <li>Internet+ techniques</li>
                    <li>Data mining</li>
                    <li>Other SI applications</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>

          {/* <h2>Call for Abstracts</h2>
          <p>
            In addition to full paper submissions, ICSI 2026 welcomes the
            submission of abstracts for presentation at the conference. Abstracts
            provide an excellent opportunity for researchers to share their
            ongoing work, preliminary results, or innovative ideas with the
            community.
          </p> */}



          <p>
            For any questions regarding abstract submission, please contact us at{" "}
            <a href="mailto:abstracts@icsi2026.org">icsi2026@iasei.org</a>.
          </p>
        </div>
      </EmptyTwo>

      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default CallForPaper;